export interface JwtPayloadSummary {
  sub?: string;
  email?: string;
  roles?: string[];
  aud?: string | string[];
}

const decodeBase64Url = (value: string): string | null => {
  try {
    const normalized = value.replace(/-/g, '+').replace(/_/g, '/');
    const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, '=');
    return atob(padded);
  } catch {
    return null;
  }
};

export const decodeJwtPayload = (token?: string): JwtPayloadSummary | null => {
  if (!token) return null;
  const raw = token.replace(/^Bearer\s+/i, '').trim();
  const parts = raw.split('.');
  if (parts.length < 2) return null;
  const decoded = decodeBase64Url(parts[1]);
  if (!decoded) return null;
  try {
    const payload = JSON.parse(decoded) as JwtPayloadSummary;
    return payload;
  } catch {
    return null;
  }
};
